<template>
    <div class="book-parts-changes">
        <PaginatedResource :fetch-method="fetchMethod">
            <template
                #default="{ loading, resource: results, isEmpty, notFound, canLoadMore, loadMore }"
            >
                <div class="page-stylesheet__results">
                    <Spinner v-if="loading" />
                    <table class="control-table book-parts-changes__table">
                        <thead class="control-table__head">
                            <tr class="control-table__row">
                                <th class="control-table__cell">
                                    <span v-t="'bookPartsChanges.results.initText'" />
                                </th>
                                <th class="control-table__cell">
                                    <span v-t="'bookPartsChanges.results.currentText'" />
                                </th>
                            </tr>
                        </thead>
                        <tbody class="control-table__body">
                            <tr v-if="!loading && isEmpty" class="control-table__row">
                                <td class="control-table__cell" colspan="2">
                                    <span v-t="'bookPartsChanges.results.noData'" />
                                </td>
                            </tr>
                            <tr v-for="item in results" :key="item.id" class="control-table__row">
                                <td class="control-table__cell">
                                    <span v-t="item.init_ssml_text" />
                                </td>
                                <td class="control-table__cell">
                                    <span
                                        v-for="(textItem, i) in item.diffText"
                                        :key="`text-item-${i}`"
                                        :style="{ background: textItem.color }"
                                        v-text="textItem.value"
                                    ></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="canLoadMore" class="book-parts-changes__loadmore">
                        <button
                            v-t="'misc.loadmore'"
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        />
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </div>
</template>

<script>
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import { fetchBookpartsChanges } from '../../api/bookparts';
import { diffWords } from 'diff';

export default {
    name: 'BookPartsChanges',
    components: {
        PaginatedResource
    },
    props: {
        bookId: {
            type: [Number, String],
            required: true
        }
    },
    methods: {
        async fetchMethod(params = {}) {
            const items = await fetchBookpartsChanges(this.bookId, params);

            items.results.forEach(item => {
                const diffText = diffWords(item.init_ssml_text, item.current_ssml_text);
                diffText.forEach(textItem => {
                    const { added = false, removed = false } = textItem;
                    let color = '#fff';

                    if (added) color = '#71A36D';
                    if (removed) color = '#FFB7B7';

                    textItem.color = color;
                });
                item.diffText = diffText;
            });

            return items;
        }
    }
};
</script>

<style lang="scss" src="./BookPartsChanges.scss"></style>
